import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  Button,
  IconButton,
  Box
} from '@mui/material';
import '../../../../App.css';
import CloseIcon from '@mui/icons-material/Close';
import useStore from '../../state-files/zustondStoreStates';

const ChatImage = ({ closeMenu, message }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const [currentUser, setName] = useState();
  const { setCommunities } = useStore(); // Use zustand store
  const { currentCommunityId } = useStore(); // Use zustand store

  // --- DIALOG CONTROL ---
  const handleClickOpen = (e) => {
    e.stopPropagation(); // Prevent Menu closing until we want it to
    setOpen(true);
  };

  const handleClose = () => {
    setError(null);
    setOpen(false);
    if (closeMenu) closeMenu();
  };

  return (
    <div>
      <Box
        component="img"
        src={message.content}
        onClick={handleClickOpen}
        sx={{
          width: "100%",
          height: "100%",
          //aspectRatio: '16 / 9',
          border: '2px solid blue',
          borderRadius: '8px',
          objectFit: "cover",
          display: "block"
        }}
        alt="Uploaded content"
      />

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl"
      >
        <IconButton
          onClick={handleClose}
          sx={{ position: 'absolute', right: 8, top: 8, color: 'white', bgcolor: 'rgba(0,0,0,0.5)', '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' } }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ p: 0, display: 'flex', backgroundColor: 'black' }}>
          <img
            src={message.content}
            alt="Full size"
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain'
            }}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ChatImage;